const filter = container => {
  // const form = container.querySelector('[data-filter-form]')
  const filterItems = container.querySelectorAll('[data-tabs-element]')
  // const filterInputs = container.querySelectorAll('[data-input]')
  const filterContent = container.querySelectorAll('[data-tab-content]')
  const submitButtons = container.querySelectorAll('[data-fleet-filter-submit]')
  const searchButton = container.querySelectorAll('[data-filter-button-search]')
  const searchField = container.querySelectorAll('[data-filter-search]')

  searchButton.forEach(btn => {
    btn.addEventListener('click', () => {
      submitButtons.forEach(button =>
        button.classList.contains('show') ? '' : btn.classList.add('show')
      )
      searchField.forEach(search => {
        search.disabled = false
        search.classList.add('fleet__filter-search--active')
      })
    })
  })

  document.addEventListener(
    'click',
    e => {
      if (!e.target.dataset.filterSearch) {
        searchField.forEach(search =>
          search.classList.remove('fleet__filter-search--active')
        )
      }
    },
    true
  )

  filterItems.forEach(item => {
    item.addEventListener('click', () => {
      filterContent.forEach(content => {
        if (item.dataset.tabsElement === content.dataset.tabContent) {
          content.querySelectorAll('[data-input]').forEach(input => {
            input.disabled = false
          })
        }
      })
    })
  })

  // filterInputs.forEach(input => {
  //   input.addEventListener('change', () => {
  //     form.submit()
  //   })
  // })
}

export default filter

if ('jQuery' in window) {
  window.jQuery(document).ajaxComplete(() => {
    filter(document.body)
  })
}
